import { api } from '../client';
import type { ISPStatusResponse } from '@/features/isp/types';

export const ispApi = {
  /**
   * Get status of all down internet connections
   * Returns clients grouped by ISP with access-filtered names
   * Uses main API which proxies to legacy and filters by permissions
   */
  getStatus: async (): Promise<ISPStatusResponse> => {
    const { data } = await api.get<ISPStatusResponse>('/isp/status');
    return data;
  },
};
